<template>
  <div class="activity">
    <tab-list :tabList="tabBar" @tabClick="tabClick" :cur="activeTab"></tab-list>
    <div class="scroll">
      <scroll
        v-if="orderArr.length"
        :data="orderArr"
        :allLoaded="allLoaded"
        @pulldown="loadData"
        @loadUp="loadup"
      >
        <div
          class="list_box"
          @click="goDetail(item.orderNo)"
          v-for="(item,index) in orderArr"
          :key="index"
        >
          <div class="list_box_top">
            <span class="createTimeCN">{{item.createTime}}</span>
            <div class="rightBox">
              <span v-if="item.status === 0 && item.payType != 6" class="time_last">剩余支付时间：{{item.lastPayTime}}</span>
              <span v-if="item.status === 0 && item.payType == 6" class="time_last">线下确认剩余：{{item.lastPayTime}}</span>
              <span  :class="[$store.state.common.theme==3 ? 'right_order_status_theme_3' : 'right_order_status']">{{item | numToText}}</span>
            </div>
          </div>
          <div class="list_box_center">
            <img class="logo" :src="item.meetingRoomImages">
            <div class="center_right_box">
              <p class="center_right_title">{{item.meetingRoomName}}</p>
              <p class="center_right_address">{{item.minDate}}</p>
              <p class="time_date">{{item.minTime}} - {{item.maxTime}} 共{{item.meetingPayTime}}小时</p>
              <p class="total_title">金额:￥{{item.payAmount|priceFormat}}</p>
              <!-- <p class="total_title" v-if="item.isFree === 2">¥ {{item.payAmount|priceFormat}}</p> -->
              <!-- <p class="total_title" v-if="item.isFree === 3">¥ {{item.payAmount|priceFormat}}(线下支付)</p> -->
            </div>
          </div>
          <div class="list_box_bottom buttonBox" v-if="item.status == 4 || item.refundTime">
            <span class="backPay">退款金额: ¥ {{item.refundAmount|priceFormat}}</span>
            <span class="evaluate_btn">查看详情</span>
          </div>
          <div class="list_box_bottom" v-else>
            <span
              v-if="item.status == 2 && item.payAmount == 0"
              class="cancel"
              @click.stop="cancel(item)"
            >取消订单</span>
            <span
              v-if="item.status == 0"
              class="cancel"
              @click.stop="cancel(item)"
            >取消订单</span>
            <span
              v-if="item.status == 0 && item.payType != 6"
              :class="['evaluate_btn',$store.state.common.theme==3?'pay_btn_3':'pay_btn']"
              @click.stop="goPayCenter(item.orderNo)"
            >立即支付</span>

            <!-- <span
              v-if="item.status == 2"
              class="cancel"
              @click.stop=""
            >申请退款</span> -->
            <!-- <span  class="cancel" v-if="(item.status==5||item.status == 2 )  && item.payAmount != 0 && !item.receiptTitle"
            @click.stop="invoiceApplication(item)">开具发票</span> -->

            <span
              v-if="item.status == 1 || item.status == 3 || (item.status == 2 && item.payAmount != 0) || (item.status==5 && !item.hasTemp)"
              class="evaluate_btn"
            >{{item.status == 2?'门禁码':'查看详情'}}</span>

            <span
              v-if="item.status == 5 && item.isEvaluate == 0 && item.hasTemp"
              class="evaluate_btn"
              @click.stop="evaluate(item)"
            >去评价</span>
            <span
              v-if="item.isEvaluate == 1"
              class="evaluate_btn"
              @click.stop="viewEvaluation(item)"
            >查看评价</span>
          </div>
        </div>
      </scroll>
      <no-message v-if="!orderArr.length && loaded"></no-message>
    </div>
  </div>
</template>

<script>
import tabList from '../../../components/tabbar';
import Scroll from '../../../components/scroll';
import NoMessage from '../../../components/nomessage';
import util from '../../../utils/util';
import {
  getMeetingOrderList,
  cancelMeetingOrder
} from '../../../utils/api';
import { mapState } from 'vuex';
import ping from '../../../utils/pingpay.js'
export default {
  name: 'meetingList',
  props: {
    selectTab: Number
  },
  components: {
    tabList,
    Scroll,
    NoMessage
  },
  filters: {
    timeChange(val){
      return val+new Date().getTime()
    },
    numToText: value => {
      if (value.status === 0) {
        return '待支付';
      } else if (value.status === 1) {
        return '已取消'; // 用户主动取消
      } else if (value.status === 2) {
        if (value.refundTime) {
          return '退款中';
        } else {
          return '已支付';
        }
      } else if (value.status === 3) {
        return '已取消'; // 过期取消
      } else if (value.status === 4) {
        return '已退款';
      } else if (value.status === 5) {
        return '已结束';
      } else if (value.status === 6) {
        return '已退订';
      } else {
        return '未定义';
      }
    }
  },
  computed: {
    ...mapState({
      common: state => state.common
    })
  },
  activated () {
    // if (this.common.isChange && this.selectTab === 1) {
    //   this.$store.commit('isChange', false);
    //   this.getMeetingOrderList();
    // }
     this.getMeetingOrderList();
  },
  watch: {
    $route (to, from) {
      if (this.selectTab === 1) {
        // 来源活动订单或者订单详情刷新列表
        if (
          from.name === 'meetingOrderDetail' ||
          from.name === 'evaluateSuccess' ||
          from.name === 'evaluate'
        ) {
          this.pageSize = 1;
          this.getMeetingOrderList();
        }
      }
    }
  },
  data () {
    return {
      canPay:true,
      tabBar: ['全部', '待支付', '已支付', '已结束', '退款'],
      orderArr: [],
      activeTab: 0,
      pageNo: 1,
      loaded: false,
      allLoaded: false
    };
  },
  created () {
    this.pageNo = 1;
    this.getMeetingOrderList();
  },
  methods: {
    // 去开票
    invoiceApplication(item){
      var urlStr = `/invoiceFrom?id=${item.orderNo}`
      if(item.receiptTitle){
         urlStr = urlStr +"&receiptTitle=" +item.receiptTitle +"&receiptType="+item.receiptType
         if(item.ratepayingNumber ){
           urlStr =urlStr +"&ratepayingNumber=" + item.ratepayingNumber;
         }

      }
      this.$router.push(urlStr)
    },
    viewEvaluation (item) {
      this.$router.push(`/evaluate/viewEvaluate?id=${item.id}`);
    },
    evaluate (item) {
      this.$router.push(`/evaluate/evaluate?id=${item.id}&referenceName=${item.meetingRoomName}&templateType=3&referenceNo=${item.orderNo}`)
    },
    goPayCenter (orderNo) {
      let that = this;
      console.log(this.canPay)
      if(!this.canPay){
        return;
      }
      this.canPay = false
      let params = {
        orderNo: orderNo,
        repairNo: '', // "报修单号",
        bussinessType:"1",//会议室1,活动2,租赁账单3,物业报修4,保洁服务5,送水服务6
        feeCode:"",
        // payType: '5', // "支付类型 0微信，1支付宝, 4万生活, 5,ping++"
        channel: 'wx_pub' // 渠道名
      };
      let header = {
        openId: this.common.openId
      };
      ping(
        params,
        header,
        res => {
          console.log(res);
          that.getMeetingOrderList()
        },
        () => {
          that.getMeetingOrderList()
        },
        () => {
          that.getMeetingOrderList()
        }
      );
      setTimeout(()=>{
        this.canPay = true
      },1000)
    },
    // 取消会议室订单
    cancel(item) {
      util.showModal('', '确定要取消该订单吗？', true, '确定', () => {
        let self = this;
        self.cancelMeetingOrder(item.orderNo)
        // if(item.payAmount == 0){
        //   util.showModal("",'已使用的免额暂不支持退还，请确认操作',true,'确定',()=>{
        //     self.cancelMeetingOrder(item.orderNo)
        //   })
        // }else{
        //   self.cancelMeetingOrder(item.orderNo)
        // }
        });
    },
    // 取消会议室订单
    cancelMeetingOrder(orderNo) {
      let self = this;
      cancelMeetingOrder({
        "orderNo":orderNo
      }).then(res => {
        console.log("res111")
        console.log(res)
        util.showToast(res.res.msg)
        if (res.res.code == 10000) {
          self.getMeetingOrderList()
        }
      })
    },

    goDetail (id) {
      this.$router.push(`/meetingOrder?id=${id}`);
    },
    tabClick (val) {
      this.activeTab = val;
      this.pageNo = 1;
      this.getMeetingOrderList();
    },
    checkTime (i) { // 将0-9的数字前面加上0，例1变为01
      if (i < 10) {
        i = '0' + i;
      }
      return i;
    },
    getMeetingOrderList () {
      this.allLoaded = false;
      let params = {
        userId: this.common.userId,
        type: this.activeTab,
        pageNo: this.pageNo,
        pageSize: 10
      };
      getMeetingOrderList(params, {
        userId: this.common.userId,
        openId: this.common.openId
      }).then(res => {
        console.log('会议室订单列表');
        console.log(res);
        this.loaded = true;
        if (res.res.code === 10000) {

          if (res.body.meetingOrderList.length !== 10) {
            this.allLoaded = true;
          }

          let orderList = res.body.meetingOrderList
          for (var key in orderList) {
             if(orderList[key].status == 0){ //待支付
              console.log('in list' + orderList[key].lastPayTime)
              var allTime =orderList[key].lastPayTime - new Date().getTime()
              var day = parseInt(allTime/1000 / 60 / 60 /24, 10); // 计算剩余的天数
              var hours = parseInt(allTime/1000 / 60 / 60 % 24, 10); // 计算剩余的小时
              var minutes = parseInt(allTime/1000 / 60 %60 , 10); // 计算剩余的分钟
              console.log('allTime == ' + allTime)
              console.log('day == ' + day)
              console.log(' hours === ' + hours)
              console.log(' minutes === ' + minutes)
            
              hours = this.checkTime(hours);
              minutes = this.checkTime(minutes);
              if(day>0){
                orderList[key].lastPayTime = day + '天' + hours + '小时' + minutes + '分'
              }else{
                orderList[key].lastPayTime = hours + '小时' + minutes + '分'
              }
            }
            // orderList[key].lastPayTime = util.formatTime(new Date(orderList[key].lastPayTime - new Date()), 2)
            orderList[key].createTime = util.formatTime(new Date(orderList[key].createTime),8)
            if(orderList[key].actBegTime){
              orderList[key].actBegTime = util.formatTime(new Date(orderList[key].actBegTime),6)
            }
            if(orderList[key].actEndTime){
              orderList[key].actEndTime = util.formatTime(new Date(orderList[key].actEndTime),6)
            }
          }


          if (this.pageNo === 1) {
            this.orderArr = orderList;
          } else {
            this.orderArr = [...this.orderArr, ...orderList];
          }
          this.timer()
        }
      });
    },
    timer(){ //页面多个定时器 //主要逻辑都在这页面更新
      // let _that = this;
      // this.temp = setInterval(()=>{
      //   console.log(_that.orderArr)
      //   _that.orderArr.forEach(item=>{
      //     item.lastPayTime = util.lastTimeCount(item.lastPayTime);
      //   })
      // },1000)
    },
    loadup () {
      if (this.allLoaded) {
        return;
      }
      this.pageNo++;
      this.getMeetingOrderList();
    },
    loadData () {
      this.pageNo = 1;
      this.getMeetingOrderList();
    }
  }
};
</script>
<style lang="less" scoped>
@import "../../../assets/css/common.less";
.activity {
  height: 100%;
  .flex(column);
  .scroll {
    flex: 1;
    height: 500px;
  }
  margin-bottom: 40px;
}
.line {
  margin: 0 30px;
  height: 1px;
  .borderB();
}
.loading_text {
  width: 100%;
  height: 80px;
  line-height: 80px;
  color: #c9c9c9;
  .fontSize(14px);
  text-align: center;
}
.list {
  background-color: rgba(243, 244, 246, 1);
  width: 100%;
}

/*-----------中间信息列表模块---------*/
.list_box {
  background: #fff;
  margin:20px;
  border-radius: 4px;
  padding:20px;
}

.list_box_top {
  height: 34px;
  padding-bottom:20px;
  .flex();
  justify-content: space-between;
  align-items: center;
}

.createTimeCN {
  .fontSize(12px);
  color: @color9;
}

.rightBox {
  .flex();
  align-items: center;
  justify-content: flex-end;
}

.right_order_status {
  .fontSize(13px);
  color: @color17;
}
.right_order_status_theme_3{
  .fontSize(13px);
  color: #EF9E04;

}
.mainC {
  color: @color17;
}

.list_box_center {
  .flex();
  padding:18px 0;
}

.logo {
  width: 240px;
  height: 168px;
  margin-right: 20px;
}

.center_right_box {
  width: 410px;
}

.center_right_title {
  .fontSize(14px);
  .textOver(100%);
  color: @color3;
  line-height: 40px;
  font-weight: bold;
  margin-bottom: 8px;
}

.center_right_address {
  .fontSize(12px);
  color: @color6;
  line-height: 37px;
  .textOver(100%);
}

.time_date {
  .fontSize(13px);
  color: @color6;
  line-height: 37px;
  margin-top: 8px;
}

.list_box_bottom {
  .flex();
  justify-content: flex-end;
  align-items: center;
}

.buttonBox {
  .flex();
  justify-content: space-between;
  align-items: center;
}

.backPay {
  .fontSize(13px);
  display: block;
  color: @color6;
}

.time_last {
  .fontSize(11px);
  color: @color17;
  line-height: 36px;
  padding: 0 14px;
  margin-right: 20px;
  color: rgba(252, 63, 86, 1);
  background:rgba(252,63,86,0.1);
  border-radius:4px;
}

.total_title {
  line-height: 30px;
  .fontSize(14px);
  color: @color3;
  margin-top: 10px;
}

.cancel {
  width: 148px;
  height: 56px;
  border-radius: 4px;
  .border();
  .fontSize(13px);
  color: #666666;
  box-sizing:border-box;
  line-height: 56px;
  text-align: center;
  margin-left: 20px;
}

.evaluate_btn {
  width: 148px;
  height: 56px;
  border-radius: 4px;
  border:0.015rem solid #dadada;
  .fontSize(13px);
  color: @color6;
  line-height: 56px;
  box-sizing:border-box;
  text-align: center;
  margin-left: 20px;
}
.pay_btn {
  color: @color17;
  .border(@color17);
}
.pay_btn_3{
  color: #A1805D;
  .border(#A1805D);
}
</style>
